/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Legacy flat SKU list (no extras). Forbidden when enrollments is set.
 */
export type HubSpotEnrollRequestExternalProductIds = string[] | null;
